type ErrorBaseProps = {
    title: string;
    subtitle: string;
    subtitle2?: string;
    illustration: React.ReactElement<SVGElement>;
};

export default function ErrorBase({
    title,
    subtitle,
    subtitle2,
    illustration,
}: ErrorBaseProps) {
    return (
        <div className="alli-mt-10 alli-text-center">
            <h1 className="alli-mx-auto alli-text-3xl alli-font-normal">
                {title}
            </h1>
            <h3 className="alli-mx-auto alli-mt-4 alli-text-xl alli-font-normal">
                {subtitle}
            </h3>
            <h4 className="alli-mx-auto alli-font-normal">{subtitle2}</h4>
            <div className="alli-mx-auto alli-flex alli-w-3/4 alli-justify-center alli-text-center">
                {illustration}
            </div>
        </div>
    );
}
